import {StyledProvider} from "./styled.provider";
import {ThemeProvider} from "./theme.provider";
import {NotificationProvider} from "./notification.provider";
import React from "react";
import {AuthenticationProvider} from "./authentication.provider";
import {Outlet} from "react-router";
import {DrawerManagerProvider} from "./drawer-manager.provider";
import {BalanceNotifierProvider} from "./balance-notifier.provider";
import {InstallPromptModalComponent} from "../components/installPromptModal/installPromptModal.component";

export const GlobalProvider = () => {
    return (
        <StyledProvider>
            <ThemeProvider>
                <NotificationProvider>
                    <DrawerManagerProvider>
                        <AuthenticationProvider>
                            <BalanceNotifierProvider />
                            <Outlet/>
                            <InstallPromptModalComponent />
                        </AuthenticationProvider>
                    </DrawerManagerProvider>
                </NotificationProvider>
            </ThemeProvider>
        </StyledProvider>
    )
}